<template>
  <div>
    <b-form-group
      label="Carnet d'entretien présenté "
      label-cols="4"
      label-for="maintenanceBookPresented"
    >
      <b-form-radio-group
        id="maintenanceBookPresented"
        buttons
        v-model="getForm.maintenanceBookPresented"
        :options="optionsNotebookMaintenance"
        size="lg"
        button-variant="outline-info"
        name="maintenanceBookPresented"
      />
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  Name: 'SpecificVe',
  computed: {
    ...mapGetters(['getForm']),
  },
  data: () => ({
    optionsNotebookMaintenance: [
      {
        value: 'non-presented',
        text: 'Non présenté',
      },
      {
        value: 'presented',
        text: 'Présenté',
      },
      {
        value: 'send-back',
        text: 'A renvoyer',
      },
    ],
  }),
};
</script>
